/* eslint-disable @typescript-eslint/no-require-imports */
import React, { useContext } from 'react'
import { TemplatePage } from '../../../../../../components/TemplatePage'
import { Image, StyleSheet, Text, View } from 'react-native'
import { globalStyle } from '../../../../../../theme/global'
import { Button } from '../../../../../../components/Button'
import { useTranslation } from 'react-i18next'
import { DOBRA } from '../../../../../../theme/fonts'
import { textColor } from '../../../../../../theme/colors'
import { InfoIco } from './InfoIco'
import { FuelContext } from '../../../../../../context/Logistics/fuel/FuelProvider'

interface Props {
  continueAction: () => void
}
const COPEC = 'Copec'

export const InstructionsView = ({ continueAction }: Props) => {
  const {
    form: { supplierName },
  } = useContext(FuelContext)
  const { t } = useTranslation()

  console.log(supplierName)
  return (
    <TemplatePage
      styleContent={{ padding: 0, marginBottom: 0 }}
      header
      title={t('Recepción combustible')}
    >
      <View style={[globalStyle.viewContainer, { padding: 0 }]}>
        <View style={styles.containerText}>
          <Text style={styles.headingText}>Instrucciones para subir la imagen correctamente:</Text>
        </View>
        <View style={styles.containerInfo}>
          <InfoIco />
          <Text style={styles.infoText}>
            La foto debe ser vertical, clara y bien enfocada. Debe coincidir con el documento de la
            imagen.
          </Text>
        </View>

        <View style={styles.containerImage}>
          <Image
            source={
              supplierName === COPEC
                ? require('../assets/CopecVoucher.png')
                : require('../assets/GuaitecasVoucher.png')
            }
            style={{ width: '90%', height: 380, borderRadius: 10 }}
            resizeMode='contain'
          />
        </View>
        <View style={styles.containerRefText}>
          <Text style={styles.imageReferenceText}>imágen de referencia</Text>
        </View>
        <View style={styles.containerBtn}>
          <Button
            label={t('Continuar')}
            onPress={continueAction}
            customStyle={{ width: 200, padding: 8, paddingVertical: 12, marginTop: 0 }}
          />
        </View>
      </View>
      <View style={styles.footer}></View>
    </TemplatePage>
  )
}

const styles = StyleSheet.create({
  containerText: {
    backgroundColor: '#D9D9D9',
    padding: 24,
  },
  headingText: {
    fontFamily: DOBRA,
    fontWeight: '500',
    fontSize: 18,
    lineHeight: 22,
    textAlign: 'center',
    color: textColor,
  },

  containerInfo: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 12,
    marginTop: 24,
    paddingHorizontal: 24,
  },

  infoText: {
    fontFamily: DOBRA,
    fontWeight: '400',
    fontSize: 14,
    flex: 1,
    color: '#859CAD',
  },

  containerImage: {
    marginTop: 24,
    alignItems: 'center',
  },

  imageReferenceText: {
    fontFamily: DOBRA,
    fontWeight: '400',
    fontSize: 12,
    color: '#859CAD',
    textAlign: 'left',
  },
  containerRefText: {
    paddingHorizontal: 40,
    marginBottom: 40,
    marginTop: -14,
  },
  containerBtn: {
    alignItems: 'center',
  },
  footer: { height: 80 },
})
